import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import type { FormItemProps, SelectProps } from 'antd';
import i18n from 'i18next';

import { routeFileSelector } from '../../../../../utilz/i18n';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentVendorBranch } from '../../hooks/use-get-shipment-vendor-branch';

interface ShipmentVendorBranchSelectProps
  extends Pick<FormItemProps, 'rules' | 'name'>,
    Pick<SelectProps, 'placeholder'> {
  label?: string;
  editMode?: boolean;
  margin?: string;
  id?: string;
  customerId: number;
  tooltip?: boolean;
  mode?: 'multiple' | 'tags';
  showAll?: boolean;
  disableValidation?: boolean;
  onChange?: () => void;
  labelWithValue?: boolean;
  isRequired?: boolean;
}

export const ShipmentVendorBranchSelect: FC<ShipmentVendorBranchSelectProps> = ({
  placeholder = i18n.t('translation:default.fields.shipmentBranch.placeholder'),
  label = i18n.t('translation:default.fields.shipmentBranch.label'),
  rules = [],
  name,
  editMode,
  margin,
  id = '',
  customerId,
  tooltip = false,
  mode,
  showAll = false,
  disableValidation = false,
  onChange = () => {},
  labelWithValue = false,
  isRequired = false,
}) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const { data: options = [], isLoading } = useGetShipmentVendorBranch({ customerKey: customerId });

  return (
    <FormSelectBox
      loading={isLoading}
      options={showAll ? [{ label: t('translation:default.options.all'), value: '-1' }, ...options] : options}
      placeholder={placeholder}
      label={label}
      isRequired={isRequired}
      rules={rules}
      name={name}
      editMode={editMode}
      margin={margin}
      id={id}
      tooltip={tooltip}
      mode={mode}
      disableValidation={disableValidation}
      onChange={onChange}
      labelWithValue={labelWithValue}
    />
  );
};
